import React, { Component } from "react";
import { connect } from "react-redux";
import "./PictureBookWarehouseSettings.scss";
import UploadPreview from "../../../components/UploadPreview/UploadPreview.js";
import ColourPreview from "../../../components/ColourPreview/ColourPreview.js";
import EditorComponent from "../../../components/EditorComponent/EditorComponent.js";
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";
import translator from "../../../utils/translator";
import Axios from "axios-https-proxy-fix";

export class PictureBookWarehouseSettings extends Component {
	resetState = () => {
		return {
			allWarehouses: [],
			warehouse: null,
			settingsLoaded: 0,
			response: {},
			table: {
				show_home_owner_homepage: 0,
				show_account_owner_homepage: 0,
				show_spec_links: 0,
				show_project_name: 0,
				show_home_owner_contact: 0,
				include_notes: 0,
				show_pricing: 0,
				show_vendor: 0,
				show_model_number: 0,
				show_sku_number: 0,
				show_product_quantity: 0,
				show_summary: 0,
				show_standard_pricing: 0,
				show_website: 0,
				picturebook_footer_show_page: 0
			},
			colours: {
				use_picturebook_colours: 0,
				colour: "#000000",
				price_colour: "#000000"
			},
			images: {
				full_cover_url: "",
				full_header_url: "",
				full_footer_url: ""
			},
			uploads: {
				picturebook_cover: "",
				picturebook_header: "",
				picturebook_footer: "",
				"delete-cover": 0,
				"delete-header": 0,
				"delete-footer": 0
			},
			footer: {
				picturebook_footer_text: "",
				picturebook_footer_text_show_last_page: 0
			}
		};
	};

	state = this.resetState();

	nestedUpdate = (state, ...keys) => {
		// UPDATES THE STATE so that nestedUpdate(state, k1, k2, k3, val) updates state.k1.k2.k3 = val
		let value = keys.pop();
		let objs = keys.reduce(
			(objs, key) => {
				objs.push(objs[objs.length - 1][key]);
				return objs;
			},
			[state]
		);
		objs.pop();
		let newState = objs.reduceRight((newState, obj, index) => {
			let next = {
				...obj,
				[keys[index]]: newState
			};
			return next;
		}, value);
		this.setState(state => newState);
	};

	nestedToggle = (state, ...keys) => {
		let val = keys.reduce((obj, key) => obj[key], state);
		keys.push(val ? 0 : 1);
		this.nestedUpdate(state, ...keys);
	};

	saveImage = (key, img) => {
		this.nestedUpdate(this.state, "uploads", key, img);
	};

	saveColour = (key, value) => {
		this.nestedUpdate(this.state, "colours", key, value);
	};

	saveHTML = text => {
		this.nestedUpdate(this.state, "footer", "picturebook_footer_text", text);
	};

	// ============= AJAX FUNCTIONS =====================

	componentDidMount = async () => {
		this.getWarehouses();
	};

	getWarehouses = async () => {
		let ajaxURL = this.props.APIUrl + "/emco_settings/get-warehouses";
		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			project_id: this.props.projectId
		};
		let APIResponse = await Axios.post(ajaxURL, data);

		if (APIResponse.data.hasOwnProperty("error")) {
			this.nestedUpdate(this.state, "response", APIResponse.data);
			return;
		}
		this.setState(state => ({
			response: {},
			allWarehouses: APIResponse.data
		}));
	};

	getSettings = async e => {
		let warehouse = e.target.previousSibling.value;

		let newState = this.resetState();
		newState.allWarehouses = this.state.allWarehouses;
		newState.warehouse = warehouse;
		this.nestedUpdate(newState, "settingsLoaded", 0);

		let ajaxURL = this.props.APIUrl + "/emco_settings/get-pbook-settings";
		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			warehouse: warehouse
		};
		let APIResponse = await Axios.post(ajaxURL, data);
		if (APIResponse.data.hasOwnProperty("error")) {
			this.nestedUpdate(newState, "response", APIResponse.data);
			return;
		}
		["table", "colours", "footer", "images"].forEach(section => {
			newState[section] = Object.fromEntries(Object.keys(this.state[section]).map(key => [key, APIResponse.data.settings.hasOwnProperty(key) && APIResponse.data.settings[key] ? APIResponse.data.settings[key] : this.state[section][key]]));
		});
		if (newState.colours.colour) newState.colours.use_picturebook_colours = 1;
		this.nestedUpdate(newState, "settingsLoaded", 1);
	};

	submit = async () => {
		let state = this.state;
		let ajaxURL = this.props.APIUrl + "/emco_settings/save-pbook-settings";

		let data = ["table", "colours", "uploads", "footer"].map(section => Object.entries(state[section])).reduce((appended, arr) => appended.concat(arr), []);
		data = Object.fromEntries(data);
		data["trendId"] = localStorage.getItem("trendId");
		data["token"] = localStorage.getItem("token");
		data["warehouse"] = state.warehouse;

		this.nestedUpdate(state, "response", { loadingbar: translator("Misc", "loading_label") });

		let APIResponse = await Axios.post(ajaxURL, data);

		if (APIResponse.data.hasOwnProperty("error")) {
			this.nestedUpdate(this.state, "response", APIResponse.data);
			return;
		}

		let newURL = this.props.APIUrl + "/emco_settings/get-pbook-settings";
		let newData = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			warehouse: state.warehouse
		};
		let newResponse = await Axios.post(newURL, newData);
		this.setState(state => ({
			response: APIResponse.data,
			images: {
				full_cover_url: newResponse.data.settings.full_cover_url,
				full_header_url: newResponse.data.settings.full_header_url,
				full_footer_url: newResponse.data.settings.full_footer_url
			},
			uploads: {
				picturebook_cover: "",
				picturebook_header: "",
				picturebook_footer: "",
				"delete-cover": 0,
				"delete-header": 0,
				"delete-footer": 0
			}
		}));
	};

	// ============= RENDER FUNCTIONS =====================

	responseCard = response => {
		if (Object.keys(response).length === 0) return null;
		let key = "error";
		if (response.hasOwnProperty("success")) key = "success";
		if (response.hasOwnProperty("loadingbar")) key = "loadingbar";
		let cardClass = "card user-profile-card response-" + key;
		return (
			<div className={cardClass}>
				<div class="card-body">{response[key]}</div>
			</div>
		);
	};

	renderTable = state => {
		let titles = {
			show_home_owner_homepage: "show_home_owner_homepage_label",
			show_account_owner_homepage: "show_account_owner_label",
			show_spec_links: "show_spec_links",
			show_project_name: "show_project_name_label",
			show_home_owner_contact: "show_home_owner_contact_label",
			include_notes: "include_notes_label",
			show_pricing: "show_pricing_label",
			show_vendor: "show_vendor_name_label",
			show_model_number: "show_model_number_label",
			show_sku_number: "show_sku_number",
			show_product_quantity: "show_product_quantity",
			show_summary: "show_summary",
			show_standard_pricing: "show_standard_pricing",
			show_website: "show_website",
			picturebook_footer_show_page: "picturebook_footer_page_show_label"
		};
		return (
			<table class="table table-bordered search-results-table checkbox-table">
				<tbody>
					{Object.entries(state.table).map(setting => {
						return (
							<tr key={setting[0]}>
								<td>
									<h3 class="application-settings-sub-header">{translator("Admin Picturebook", titles[setting[0]])}</h3>
								</td>
								<td class="settings-checkbox-td">
									<input type="checkbox" class="dn" id={setting[0]} checked={setting[1]} onChange={() => this.nestedToggle(state, "table", setting[0])} />
									<label class="settings-label" htmlFor={setting[0]}>
										<div class="settings-label-icon">&#10003;</div>
									</label>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		);
	};

	renderColours = state => {
		return (
			<table class="table table-bordered search-results-table checkbox-table">
				<tbody>
					<tr>
						<td>
							<h3 class="application-settings-sub-header">{translator("Admin Picturebook", "custom_picturebook_colours")}</h3>
						</td>
						<td class="settings-checkbox-td">
							<input type="checkbox" class="dn" id="use_picturebook_colours" checked={state.colours.use_picturebook_colours} onChange={() => this.nestedToggle(state, "colours", "use_picturebook_colours")} />
							<label class="settings-label" htmlFor="use_picturebook_colours">
								<div class="settings-label-icon">&#10003;</div>
							</label>
						</td>
					</tr>
					{state.colours.use_picturebook_colours ? (
						<React.Fragment>
							<tr>
								<td>
									<h3 class="application-settings-sub-header">{translator("Admin Picturebook", "colour_band_label")}</h3>
								</td>
								<td class="settings-checkbox-td">
									<ColourPreview stateKey={"colour"} color={{ hex: state.colours.colour }} saveColour={this.saveColour} />
								</td>
							</tr>
							<tr>
								<td>
									<h3 class="application-settings-sub-header">{translator("Admin Picturebook", "colour_price_label")}</h3>
								</td>
								<td class="settings-checkbox-td">
									<ColourPreview stateKey={"price_colour"} color={{ hex: state.colours.price_colour }} saveColour={this.saveColour} />
								</td>
							</tr>
						</React.Fragment>
					) : null}
				</tbody>
			</table>
		);
	};

	renderUploads = state => {
		let sections = {
			cover: {
				title: translator("Admin Picturebook", "picturebook_image_label"),
				subtitle: translator("Admin Picturebook", "picturebook_update_message"),
				key: "picturebook_cover",
				delete: "delete-cover",
				image: state.images.full_cover_url
			},
			header: {
				title: translator("Admin Picturebook", "picturebook_image_label"),
				subtitle: translator("Admin Picturebook", "picturebook_header_update_message"),
				key: "picturebook_header",
				delete: "delete-header",
				image: state.images.full_header_url
			},
			footer: {
				title: translator("Admin Picturebook", "picturebook_footer_image_label"),
				subtitle: translator("Admin Picturebook", "picturebook_footer_update_message"),
				key: "picturebook_footer",
				delete: "delete-footer",
				image: state.images.full_footer_url
			}
		};
		return Object.values(sections).map(upload => {
			return (
				<div class="pbook-settings-upload-section" key={upload.key}>
					<div class="form-group mt2">
						<h2 style={{ color: "#16448e" }}>{upload.title}:</h2>
						<p>
							<em>{upload.subtitle}</em>
						</p>
					</div>
					<UploadPreview preview={upload.image} saveImage={this.saveImage} stateKey={upload.key} />

					<div class="custom-checkbox-wrapper">
						<input type="checkbox" class="dn" id={upload.delete} onChange={() => this.nestedToggle(state, "uploads", upload.delete)} />
						<label class="custom-checkbox-label" htmlFor={upload.delete}>
							<div class="label-box"></div>
							<div class="label-message">{translator("Misc", "delete_label")}</div>
						</label>
					</div>
				</div>
			);
		});
	};

	renderSettings = state => {
		return (
			<div class="card user-profile-card">
				<div class="card-body">
					{this.renderTable(state)}
					{this.renderColours(state)}
					{this.renderUploads(state)}

					<div class="pbook-settings-upload-section">
						<div class="form-group mt2">
							<h2 style={{ color: "#16448e" }}>{translator("Admin Picturebook", "picturebook_footer_text_label")}:</h2>
						</div>

						{state.settingsLoaded ? <EditorComponent loadedText={state.footer.picturebook_footer_text} saveHTML={this.saveHTML} /> : null}

						<div class="custom-checkbox-wrapper">
							<input type="checkbox" class="dn" id="show_footer_text_last_page" checked={state.footer.picturebook_footer_text_show_last_page} onChange={() => this.nestedToggle(state, "footer", "picturebook_footer_text_show_last_page")} />
							<label class="custom-checkbox-label" htmlFor="show_footer_text_last_page">
								<div class="label-box"></div>
								<div class="label-message">{translator("Admin Picturebook", "picturebook_footer_text_show_label")}</div>
							</label>
						</div>
					</div>

					<button type="button" class="btn btn-primary pbook-settings-submit" onClick={this.submit}>
						{translator("Admin Picturebook", "submit_btn")}
					</button>
				</div>
			</div>
		);
	};

	render() {
		let state = this.state;

		let main = (
			<>
				<div class="card user-profile-card mb1">
					<div class="card-body">
						<form class="pb-warehouse-select">
							<select class="dropdown-toggle form-control" type="button" id="dropdownMenuButton">
								<option>{translator("Admin Picturebook", "select_warehouse")}</option>
								{state.allWarehouses.map(warehouse => {
									return (
										<option key={warehouse.warehouse} value={warehouse.warehouse}>
											{warehouse.warehouse}
										</option>
									);
								})}
							</select>
							<button type="button" class="btn btn-primary" onClick={this.getSettings}>
								{translator("Misc", "select_label")}
							</button>
						</form>
					</div>
				</div>

				{state.settingsLoaded ? this.renderSettings(state) : null}

				{this.responseCard(state.response)}
			</>
		);

		return (
			<SettingsWrapper header={translator("Admin Menu", "picturebook_warehouse_settings_header")} main={main} />
		);
	}
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl
});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PictureBookWarehouseSettings);
